import { QaroniEnumInformation } from '../qaroni-enum-information/qaroni-enum-information';

export enum LanguageEnum {
  default = 'es',
  es = 'es',
}

export const LanguageEnumArray = [LanguageEnum.es];

export const LanguageEnumInfo: QaroniEnumInformation<LanguageEnum> = {
  [LanguageEnum.default]: {
    name: 'es',
  },
};
